import { render, staticRenderFns } from "./landlord.vue?vue&type=template&id=3ccaffa9&scoped=true&"
import script from "./landlord.vue?vue&type=script&lang=js&"
export * from "./landlord.vue?vue&type=script&lang=js&"
import style0 from "./landlord.vue?vue&type=style&index=0&id=3ccaffa9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccaffa9",
  null
  
)

export default component.exports